module.exports = __webpack_public_path__ + "img/gear.5ee92b80.png";